import type { BingoResultToShowType, MetagameBingoEvent } from '../../../../../stores/bingo/types';
import type { BingoWidgetDataType, BingoWidgetType } from '../../../types';

import { BingoLiveWideWidget } from './BingoLiveWideWidget/BingoLiveWideWidget';
import { BingoRewardWideWidget } from './BingoRewardWideWidget/BingoRewardWideWidget';
import { BingoStartingSoonWideWidget } from './BingoStartingSoonWideWidget/BingoStartingSoonWideWidget';
import { BingoUpcomingWideWidget } from './BingoUpcomingWideWidget/BingoUpcomingWideWidget';

interface BingoWideWidgetProps {
  data: BingoWidgetDataType;
  widgetType: BingoWidgetType;
}

export function BingoWideWidget(props: BingoWideWidgetProps) {
  const { widgetType, data } = props;

  switch (widgetType) {
    case 'upcoming':
      return <BingoUpcomingWideWidget />;
    case 'live':
      return <BingoLiveWideWidget event={data.event as MetagameBingoEvent} />;
    case 'startingSoon':
      return <BingoStartingSoonWideWidget event={data.event as MetagameBingoEvent} />;
    case 'reward':
      return <BingoRewardWideWidget event={data.event as BingoResultToShowType} />;
    default:
      return null;
  }
}
